<template>
  <button
    class="btn btn-link p-0 modal-close-button"
    :class="{ dark: dark, 'large-close': large }"
    @click="handleClick"
  />
</template>

<style lang="scss" scoped>
@import "../variables.scss";

.modal-close-button {
  position: absolute;
  right: 5px;
  top: 5px;
}

.modal-close-button {
  border-radius: 0;
  position: absolute;
  width: 20px;
  height: 20px;

  &.large-close {
    width: 28px;
    height: 28px;
  }

  &.dark {
    padding: 0px;
    top: 30px;
    right: 30px;

    @media screen and (max-width: 680px) {
      top: 15px;
      right: 15px;
    }

    &:before, &:after {
      background-color: $primary-color;
    }
  }
}

.modal-close-button:before, .modal-close-button:after {
  position: absolute;
  top: 0;
  left: 9px;
  content: ' ';
  height: 21px;
  width: 2px;
  background-color: #fff;
}

.modal-close-button.large-close:before, .modal-close-button.large-close:after {
  height: 28px;
  width: 3px;
  left: 12px;
}

.modal-close-button:before {
  transform: rotate(45deg);
}

.modal-close-button:after {
  transform: rotate(-45deg);
}
</style>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('clickClose');
    },
  },
};
</script>
